import initialState from './initialState'
import {
    SET_ITEMS_CREATION_FORM_IS_FOCUSED,
    SET_ITEMS_CREATION_FORM_IS_EMPTY
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_ITEMS_CREATION_FORM_IS_FOCUSED:
            return {
                ...state,
                isFocused: action.isFocused
            }

        case SET_ITEMS_CREATION_FORM_IS_EMPTY:
            return {
                ...state,
                isEmpty: action.isEmpty
            }

        default:
            return state
    }
}
